<template>
  <v-chip v-if="actionsStatus && actionsStatus.toBeProcessed>0" color="warning"
          :text="actionsStatus.toBeProcessed"
          class="text-subtitle-2 font-weight-bold pl-1 mr-1"
          variant="flat"
          size="small">
    <template #prepend>
      <v-icon icon="mdi-timer-outline" size="18" class="mr-0"/>
    </template>
  </v-chip>
  <v-chip v-if="actionsStatus && actionsStatus.inProgress>0" color="primary"
          :text="actionsStatus.inProgress"
          class="text-subtitle-2 font-weight-bold pl-1"
          variant="flat"
          size="small">
    <template #prepend>
      <v-icon icon="mdi-fire" size="18"/>
    </template>
  </v-chip>
</template>

<script setup lang="ts">
import type {ActionsStatus} from "~/types/Perimeter";

defineProps<{
  actionsStatus: ActionsStatus
}>()
</script>

